export default __webpack_public_path__ + "static/media/23.a012dab0.jpg";